export function getDataAttributes(
  element: HTMLElement,
): Record<string, string> {
  const data: Record<string, string> = {};
  for (const attr of element.attributes) {
    if (attr.name.startsWith("data-")) {
      data[attr.name] = attr.value;
    }
  }
  return data;
}
